import { RootState } from '@/store/state';
import { GetterTree } from 'vuex';
import { GameStepsState } from '@/store/modules/gamesteps/state';

export type Getters<S = GameStepsState> = {
  currentStep(state: S): number | undefined;
  totalSteps(state: S): number | undefined;
};
export interface NamespacedGetters {
  'gamesteps/currentStep': number | undefined;
  'gamesteps/totalSteps': number | undefined;
}

export const getters: GetterTree<GameStepsState, RootState> & Getters = {
  currentStep: (state) => {
    return state.currentStep ?? undefined;
  },
  totalSteps: (state) => {
    return state.totalSteps ?? undefined;
  }
};
